import { DetectUA } from 'detect-ua';

const ua = new DetectUA();
export default ua;
